import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class GraphyService {
  private baseUrl = environment.apiUrls.master;

  constructor(private http: HttpClient) {}

  getEnrollments(status): Observable<any> {
    return this.http.get(`${this.baseUrl}/graphy/enrollment?status=${status}`, { headers: this.getHeaders() });
  }

  getLearners(status): Observable<any> {
    return this.http.get(`${this.baseUrl}/graphy/learner?status=${status}`, { headers: this.getHeaders() });
  }

  private getHeaders(): HttpHeaders {
    const token = localStorage.getItem('token');
    return new HttpHeaders({ Authorization: `Bearer ${token}` });
  }
} 